<template>
  <DefaultCrudView
    :breadcrumbsItems="breadcrumbs"
  >
    <template slot="content">

      <v-container
        class="align-self-center"
      >
        <v-row class="justify-center">
          <v-col
            v-for="agent in aiAgents"
            :key="agent.application_instance_id"
            class="d-flex child-flex py-2 px-2"
            xl="2"
            lg="3"
            md="4"
            sm="6"
            cols="12"
          >
            <AgentCard
              :agent="agent"
              @click="$router.push({ name: agent.config.type, params: { appId: agent.application_instance_id, contentAppId: agent.config.content_app_id } })"
            />
          </v-col>
        </v-row>
      </v-container>

    </template>
  </DefaultCrudView>
</template>

<style scoped>
  ::v-deep .table-container {
    display: flex;
    min-height: 70vh;
  }

  ::v-deep .v-breadcrumbs__item i {
    vertical-align: baseline;
    padding-right: 6px;
  }
</style>

<script>

import { mapState } from 'vuex'

import DefaultCrudView from '@/components/DefaultCrudView.vue'
import AgentCard from '@/components/ai_workforce/AgentCard.vue'

export default {
  name: "AiWorkforceHome",

  components: {
    DefaultCrudView,
    AgentCard,
  },

  computed: {
    ...mapState({
      userApplications: state => state.app.userApplications,
    }),

    breadcrumbs() {
      return [
        {
          text: this.$t('ai_workforce'),
          prependIcon: 'mdi-robot',
        },
      ]
    },

    aiAgents() {
      return this.userApplications.filter(application => application.application_key == "ai_workforce")
        .map(application => {
          return {...application, config: this.parseApplicationConfig(application.config)}
        })
    },
  },

  methods: {
    parseApplicationConfig(string) {
      try {
        return JSON.parse(string)
      } catch (e) {
        return {}
      }
    },
  }
}

</script>
